import { MarkdownDocPage } from "@/components/MarkdownDocPage";
import { createFileRoute } from "@tanstack/react-router";
import procurementMd from "../../../docs/phase1-procurement-guide.md?raw";

export const Route = createFileRoute("/docs/phase1/procurement")({
	component: () => <MarkdownDocPage source={procurementMd} />,
});
